import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

import {ChakraProvider} from "@chakra-ui/react";
import Index from "./routes/index.jsx";
import theme from './theme/theme.js';

const router = createBrowserRouter([
    {
        path: "/",
        id: 'index',
        element: <Index/>,
    },
], {
    future: {
        v7_startTransition: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_relativeSplatPath: true,
        v7_skipActionErrorRevalidation: true,
    }
});

function App() {
    return (
        <ChakraProvider value={theme}>
            <RouterProvider router={router}/>
        </ChakraProvider>
    );
}

export default App;
